import React from 'react';
import styled from 'styled-components';
import { Dropdown } from 'semantic-ui-react';
import createMessageTag from '../apollo/createMessageTag';
import updateMessageTag from '../apollo/updateMessageTag';
import { useMutation } from '@apollo/client';
import {
  ICreateMessageTagMutation,
  ICreateMessageTagMutationVariables,
  IUpdateMessageTagMutation,
  IUpdateMessageTagMutationVariables,
} from '../../../../../utils/apollo/graphqlSchema';
const DropdownItem = styled(Dropdown.Item)`
  &&& {
    width: 140px !important;
    overflow: visible;
    .text {
      font: inherit;
      font-size: 14px;
      font-weight: 500;
      color: #8a94bd;
    }
  }
`;

export default function TaskMenu(props: any) {
  // check if Task Tag is already created.
  const taskTag = props.message.tags.find((tag: any) => {
    if (tag.kind === 'TASK') {
      return true;
    }
    return false;
  });

  const [updateMessage] = useMutation<
    IUpdateMessageTagMutation,
    IUpdateMessageTagMutationVariables
  >(updateMessageTag, {});
  const [createMessage] = useMutation<
    ICreateMessageTagMutation,
    ICreateMessageTagMutationVariables
  >(createMessageTag, {});
  let taskInput: any = {};
  if (taskTag) {
    taskInput = {
      tagId: taskTag.id,
      state: 'CLOSED',
      text: '',
    };
  } else {
    taskInput = {
      messageId: props.message.id,
      kind: 'TASK',
      text: '',
    };
  }
  // update state and then post the update task mutation
  const updateTaskTag = (newState: string) => {
    taskInput.state = newState;
    updateMessage({
      variables: { input: taskInput },
    });
  };

  return taskTag ? (
    <>
      {/* If task tag exists, and state is open or completed, click to
  close or open the task tag */}
      <DropdownItem
        text={
          taskTag.state === 'OPEN' || taskTag.state === 'COMPLETED'
            ? 'Untask'
            : 'Mark as Task'
        }
        onClick={() =>
          updateTaskTag(
            taskTag.state === 'OPEN' || taskTag.state === 'COMPLETED'
              ? 'CLOSED'
              : 'OPEN',
          )
        }
      />
      {/* if tag state is OPEN only, user can mark it as completed */}
      {taskTag.state !== 'COMPLETED' && taskTag.state !== 'CLOSED' && (
        <>
          <Dropdown.Divider />
          <DropdownItem
            text="Mark Task Done"
            onClick={() => updateTaskTag('COMPLETED')}
          />
        </>
      )}
      {/* if tag is completed, user can mark it as uncompleted */}
      {taskTag.state === 'COMPLETED' && (
        <>
          <Dropdown.Divider />
          <DropdownItem
            text="Undone Task"
            onClick={() => updateTaskTag('OPEN')}
          />
        </>
      )}
    </>
  ) : (
    // if task tag is not created, create the tag when click.
    <DropdownItem
      text="Mark as Task"
      onClick={() => {
        createMessage({
          variables: { input: taskInput },
        });
      }}
    />
  );
}
